import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components';

export const PopupButton = ({ children, url, onClick, isDisabled }) => (
  <Button
    className="big"
    type="button"
    target="_blank"
    disabled={isDisabled}
    onClick={onClick}
    href={url}
  >
    {children}
  </Button>
);

PopupButton.propTypes = {
  url: PropTypes.string,
  children: PropTypes.string,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
};
